import React from 'react';
import { RaioXForm } from './RaioXForm';

const STEPS = [
  ['01', 'Você me conta', 'Nome, empresa e o @ do Instagram. Leva menos de 1 minuto.'],
  ['02', 'Eu analiso pessoalmente', 'Perfil, imagem, mensagem e o que a concorrência está fazendo.'],
  ['03', 'Em até 24h, o plano', 'Você recebe no WhatsApp o que fazer para crescer no digital.'],
];

export const RaioXSection = () => (
  <section id="raio-x" className="relative py-28 sm:py-36 overflow-hidden br-grain" data-testid="raio-x-section">
    <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-[#4ECDC4]/60 to-transparent" />
    <div className="absolute left-1/2 top-20 -translate-x-1/2 h-[500px] w-[800px] rounded-full bg-[#4ECDC4]/10 blur-[150px]" />
    <div className="relative mx-auto max-w-7xl px-5 sm:px-8 grid lg:grid-cols-2 gap-16 items-start">
      <div>
        <p className="br-mono text-[11px] text-[var(--br-teal)]">Grátis · até 24h</p>
        <h2 className="mt-5 text-4xl sm:text-6xl font-semibold leading-[1.05]">Raio-X <span className="italic text-[var(--br-teal)]">da Marca</span></h2>
        <p className="mt-6 text-base sm:text-lg text-[var(--br-muted)] max-w-lg leading-relaxed">
          Antes de falar em orçamento, eu olho a sua marca de perto. Você recebe um diagnóstico direto, com o que está funcionando, o que está te custando clientes e por onde começar.
        </p>
        <ol className="mt-12 space-y-8">
          {STEPS.map(([n, t, d]) => (
            <li key={n} className="flex gap-6" data-testid={`raio-x-step-${n}`}>
              <span className="br-serif text-3xl text-[var(--br-teal)] w-10 shrink-0">{n}</span>
              <div>
                <h3 className="text-xl font-semibold">{t}</h3>
                <p className="mt-1 text-[var(--br-muted)]">{d}</p>
              </div>
            </li>
          ))}
        </ol>
      </div>
      <RaioXForm />
    </div>
  </section>
);
